<template>
  <v-dialog v-model="updateArticleInfoDialog" width="800">
    <v-card v-if="$vuetify.breakpoint.smAndUp">
      <v-toolbar flat>
        <v-spacer></v-spacer>
        <span class="display-1 text-uppercase font-weight-bold">{{$t('infoDialogs.private.updateArticle.Title')}}</span>
        <v-spacer></v-spacer>
        <v-btn color="error" :title="$t('infoDialogs.private.updateArticle.Close window')" class="ma-2" outlined icon large @click="closeDialog">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <p class="pr-5 text--primary title pt-5">{{$t('infoDialogs.private.updateArticle.PageDescription')}}</p>
        <v-divider></v-divider>
        <v-divider></v-divider>
        <v-row>
          <v-col md="12" class="ml-0 pl-0 d-flex pt-10">
            <span class="body-1 text--primary font-weight-bold pt-5 pr-5">{{$t('infoDialogs.private.updateArticle.PageActionsOne')}}:</span>
            <span>
              <v-switch v-model="isPublished" :label="`${PublishText}`"></v-switch>
            </span>
          </v-col>
          <v-col md="12" class="ml-0 pl-0 d-flex ma-0 pa-0">
            <span class="body-1 text--primary font-weight-bold pt-5 pr-5">{{$t('infoDialogs.private.updateArticle.PageActionsTwo')}}:</span>
            <span>
              <v-switch v-model="isComments" :label="`${CommentsEnabled}`"></v-switch>
            </span>
          </v-col>
          <v-col md="12" class="ma-0 pa-0 pt-5">
            <span class="body-1 text--primary font-weight-bold">{{$t('infoDialogs.private.updateArticle.PageActionsThree')}}</span>
          </v-col>
          <v-col md="12" class="ma-0 pa-0 pt-10">
            <span class="body-1 text--primary font-weight-bold pr-5">{{$t('infoDialogs.private.updateArticle.PageActionsFour')}}</span>
            <span><v-btn color="success">{{$t('infoDialogs.private.updateArticle.Title')}}</v-btn></span>
          </v-col>
          <v-col md="12" class="ma-0 pa-0 pt-10 pb-5">
            <span class="body-1 text--primary font-weight-bold pr-5">{{$t('infoDialogs.private.updateArticle.PageActionsFive')}}</span>
            <span><v-btn color="error">{{$t('infoDialogs.private.updateArticle.Delete')}}</v-btn></span>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-card v-else>
      <v-row class="ma-0 pa-0">
        <!--Title and close button-->
        <v-col cols="12" class="py-0">
          <v-row class="ma-0 pa-0">
            <v-col cols="8" class="pa-0 pt-3">
              <span class="title text-uppercase font-weight-bold">{{$t('infoDialogs.private.updateArticle.Title')}}</span>
            </v-col>
            <v-spacer></v-spacer>
            <v-col cols="auto" class="py-0">
              <v-btn color="error" :title="$t('infoDialogs.private.updateArticle.Close window')" class="ma-2" outlined icon large @click="closeDialog">
                <v-icon>close</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
        <!--Publish switch-->
        <v-col cols="12" class="py-0">
          <v-row class="ma-0 pa-0">
            <!--Publishing description-->
            <v-col cols="12" class="py-0">
              <span class="body-1 text--primary font-weight-bold pt-5 pr-5">{{$t('infoDialogs.private.updateArticle.PageActionsOne')}}:</span>
            </v-col>
            <!--Publish switch-->
            <v-col cols="12" class="py-0">
              <v-switch v-model="isPublished" :label="`${PublishText}`"></v-switch>
            </v-col>
          </v-row>
        </v-col>
        <!--Comment switch-->
        <v-col cols="12" class="py-0">
          <v-row class="ma-0 pa-0">
            <!--Comment Description-->
            <v-col cols="12" class="py-0">
              <span class="body-1 text--primary font-weight-bold pt-5 pr-5">{{$t('infoDialogs.private.updateArticle.PageActionsTwo')}}:</span>
            </v-col>
            <!--Comment Switch-->
            <v-col cols="12" class="py-0">
              <v-switch v-model="isComments" :label="`${CommentsEnabled}`"></v-switch>
            </v-col>
          </v-row>
        </v-col>
        <!--Info on Geo and Hash tags-->
        <v-col cols="12" class="py-3 pl-6">
          <span class="body-1 text--primary font-weight-bold">{{$t('infoDialogs.private.updateArticle.PageActionsThree')}}</span>
        </v-col>
        <!--Info on image-->
        <v-col cols="12" class="py-3 pl-6">
          <span class="body-1 text--primary font-weight-bold">{{$t('infoDialogs.private.updateArticle.PageActionsFour')}}</span>
        </v-col>
        <!--Save button and description-->
        <v-col cols="12" class="py-3">
          <v-row class="ma-0 pa-0">
            <!--Description-->
            <v-col cols="12" class="py-0 pb-3">
              <span class="body-1 text--primary font-weight-bold">{{$t('infoDialogs.private.updateArticle.PageActionsFive')}}</span>
            </v-col>
            <!--Submit button-->
            <v-col cols="12" class="py-0">
              <v-btn block color="success">{{$t('infoDialogs.private.updateArticle.Title')}}</v-btn>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-card>
  </v-dialog>
</template>

<script>
// Import the i18n - This may need to be modified
import messages from "../../modules/lang/export";
export default {
  // Communicate with i18n
  i18n: { messages },
  data(){
    return{
      // Define the dialog v-model that we are using
      updateArticleInfoDialog:false,
      isPublished:false,
      isComments: false,
    }
  },
  methods: {
    // Opening the dialog through the ref
    openDialog() {
      this.updateArticleInfoDialog = true;
    },
    // Close the dialog
    closeDialog() {
      this.updateArticleInfoDialog = false;
    }
  },
  computed: {
    PublishText() {
      if (this.isPublished == false) {
        return this.$t('infoDialogs.private.updateArticle.Not Published')
      } else {
        return this.$t('infoDialogs.private.updateArticle.Published')
      }
    },

    CommentsEnabled() {
      if (this.isComments == false) {
        return this.$t('infoDialogs.private.updateArticle.Comments are not enabled')
      } else {
        return this.$t('infoDialogs.private.updateArticle.Comments are enabled')
      }
    }
  }
}
</script>